import api, { apiInternal } from '../api';

export async function getStaffsByEstaId(estaId) {
  const { data } = await api.post(`${apiInternal}/establishment/params/getStaffs`, { esta_id: estaId });  
  return data;
}

export async function getStaffById(estaId, Id) {
  const { data } = await api.post(`${apiInternal}/staff/detail`, { esta_id: estaId, staf_id: Id });
  return data;
}

export async function setStaff( staff) {
const { data } = await api.post(`${apiInternal}/staff/update`, staff );
return data;

}
export async function getMappedStaffs(estaId, cntId) {
  const {data } = await api.post(`${apiInternal}/establishment/params/GetMappedStaffs`, { esta_id: estaId, cnt_id: cntId });
  return data;
}

export async function setMappingStaff(params) {
  const {data} = await api.post(`${apiInternal}/staff/SetMappingStaff`, params);
  return data;
}

